import React from 'react';

import { ICategory } from '@Hotels-at-Home/hah-fe-core/dist/types/category';

interface IProps {
  category: ICategory;
}

const CategoryHeader = ({ category }: IProps) => (
  <div id="category-header" className="item ctg-header">
    <div className="stack">
      <h1 className="name">
        <span>{category.name}</span>
      </h1>
    </div>
  </div>
);

export default CategoryHeader;
